import { MultiSelect } from "@mantine/core";
import { Dispatch, useCallback } from "react";
import { HeldEmailQueueAction } from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailState } from "../../../services/admin/systemEmails.service";

interface Props {
  value: HeldEmailState[];
  dispatch: Dispatch<HeldEmailQueueAction>;
}
const OPTIONS = [
  { value: "pending", label: "Waiting for review" },
  { value: "blocked", label: "Blocked" },
  { value: "failed", label: "Release failed" },
  { value: "sending", label: "Sending" },
  { value: "sent", label: "Sent" },
  { value: "cancelled", label: "Cancelled" },
];

export function HeldEmailStateFilter({ value, dispatch }: Props) {
  const handleChange = useCallback(
    (values: string[]) =>
      dispatch({ type: "states", value: values as HeldEmailState[] }),
    [dispatch]
  );
  return (
    <MultiSelect
      clearable
      data={OPTIONS}
      label="Status"
      onChange={handleChange}
      placeholder="All statuses"
      value={value}
    />
  );
}
